/* TURN: mobile swipe gallery on product cards. Keeps the gallery the exact height of the card image
   (.card__inner) and moves the 2px progress line with the scroll. Slides are plain links.
   Conservative syntax, everything guarded, never breaks the page. */
(function () {
  'use strict';

  try {
    if (window.__turnCardGallery) return;
    window.__turnCardGallery = true;
  } catch (e) {
    return;
  }

  function closestEl(node, selector) {
    while (node && node.nodeType !== 1) node = node.parentNode;
    if (!node || typeof node.closest !== 'function') return null;
    return node.closest(selector);
  }

  /* Mobile gallery: move the 2px progress segment with the horizontal scroll position. */
  var galleryFrame = 0;
  var pendingTracks = [];

  function updateGallery(track) {
    var width = track.clientWidth;
    var gallery = track.parentNode;
    if (!width || !gallery || !gallery.style) return;
    var pos = Math.round((track.scrollLeft / width) * 1000) / 1000;
    gallery.style.setProperty('--turn-gallery-pos', String(pos));
  }

  function flushGalleries() {
    galleryFrame = 0;
    var list = pendingTracks;
    pendingTracks = [];
    for (var i = 0; i < list.length; i++) updateGallery(list[i]);
  }

  function onGalleryScroll(event) {
    try {
      var track = event.target;
      if (!track || !track.classList || !track.classList.contains('turn-card-gallery__track')) return;
      if (pendingTracks.indexOf(track) === -1) pendingTracks.push(track);
      if (galleryFrame) return;
      if (typeof window.requestAnimationFrame === 'function') {
        galleryFrame = window.requestAnimationFrame(flushGalleries);
      } else {
        galleryFrame = window.setTimeout(flushGalleries, 16);
      }
    } catch (e) {
      /* never break the page */
    }
  }

  try {
    document.addEventListener('scroll', onGalleryScroll, { capture: true, passive: true });
  } catch (e) {
    document.addEventListener('scroll', onGalleryScroll, true);
  }

  /* Mobile gallery: match the layer to the real image box (.card__inner), so it fully covers the
     card image and the progress line sits right under it. The gallery stays hidden (CSS) until this
     has run, so the photos never visibly move while the page loads (data-turn-sized). */
  var resizeObserver = null;

  function sizeGallery(gallery) {
    try {
      var card = closestEl(gallery, '.card');
      var inner = card ? card.querySelector('.card__inner') : null;
      if (!inner) return;
      var height = inner.offsetHeight;
      if (!height) return;
      gallery.style.paddingBottom = '0';
      gallery.style.height = height + 'px';
      if (!gallery.hasAttribute('data-turn-sized')) gallery.setAttribute('data-turn-sized', '');
    } catch (e) {
      /* keep CSS fallback */
    }
  }

  function sizeAllGalleries() {
    var galleries = document.querySelectorAll('.turn-card-gallery');
    for (var i = 0; i < galleries.length; i++) sizeGallery(galleries[i]);
  }

  function initGalleries() {
    try {
      var galleries = document.querySelectorAll('.turn-card-gallery:not([data-turn-init])');
      for (var i = 0; i < galleries.length; i++) {
        var gallery = galleries[i];
        gallery.setAttribute('data-turn-init', '');
        sizeGallery(gallery);
        if (resizeObserver) {
          var card = closestEl(gallery, '.card');
          var inner = card ? card.querySelector('.card__inner') : null;
          if (inner) resizeObserver.observe(inner);
        }
      }
    } catch (e) {
      /* never break the page */
    }
  }

  try {
    if (typeof window.ResizeObserver === 'function') {
      resizeObserver = new window.ResizeObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var card = closestEl(entries[i].target, '.card');
          var gallery = card ? card.querySelector('.turn-card-gallery') : null;
          if (gallery) sizeGallery(gallery);
        }
      });
    } else {
      window.addEventListener('resize', sizeAllGalleries);
    }
  } catch (e) {
    resizeObserver = null;
    window.addEventListener('resize', sizeAllGalleries);
  }

  initGalleries();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleries);
  }
  window.addEventListener('load', sizeAllGalleries);

  /* Cards re-rendered by filtering / sorting / pagination */
  try {
    if (typeof window.MutationObserver === 'function') {
      var pendingInit = 0;
      new window.MutationObserver(function () {
        if (pendingInit) return;
        pendingInit = window.setTimeout(function () {
          pendingInit = 0;
          initGalleries();
        }, 50);
      }).observe(document.body || document.documentElement, { childList: true, subtree: true });
    }
  } catch (e) {
    /* ignore */
  }
})();